<data-list
  [style.minWidth.px]="anchor()?.offsetWidth + 20"
  toggleElement
  [xAxis]="xAxis()"
  [yAxis]="yAxis()"
  [anchor]="anchor()"
  [toggleByAnchor]="false"
  [closeInternalClick]="false"
  [distance]="16"
  (showChange)="show.set($event)"
  [show]="show()"
  class="overflow-hidden absolute rounded-lg border border-solid border-border-solid dropshadow-lg bg-background w-[212px] my-[4px] py-1.5"
>
  @for (option of dataSource(); track option.id) {
    <div class="flex items-center justify-between w-full px-2 transition-colors">
      <div
        class="flex items-center w-full px-[10px] py-[6px] h-[36px]"
        [attr.tabIndex]="0"
        [ngStyle]="{
          cursor: isDisabled() ? 'not-allowed' : 'default'
        }"
      >
        <div
          class="flex flex-1 shrink items-center text-sm font-semibold leading-6"
          [ngClass]="{
            'text-foreground': !isDisabled() && option.isChecked,
            'text-muted-foreground': isDisabled() || !option.isChecked
          }"
        >
          {{ option.description | translate }}
        </div>
        <lib-switch
          [id]="'switch-' + option.id"
          [value]="option.isChecked"
          [state]="option.state"
          (valueChange)="onSwitchChange(option, $event, option.state)"
          class="ml-2"
        ></lib-switch>
      </div>
    </div>
  }
</data-list>
